{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "チェックアウト",
      "checkInDeprecated": "チェックイン（非推奨）",
      "checkIn": "チェックイン",
      "receivedLoadInspection": "入荷貨物の検品",
      "shippedLoadVerification": "出荷貨物の確認",
      "appointmentsPerLoadType": "荷物の種類別の予約",
      "assetDetails": "アセットの詳細",
      "yardManagementSystem": "ヤード管理システム",
      "smartGateIntegration": "SmartGate 連携",
      "gateManagement": "ゲート管理",
      "idValidation": "本人確認",
      "appointmentCompleted": "予約完了"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>電話番号</strong>と<strong>運送会社</strong>はデフォルトで収集されます"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "予定された到着と予定外の到着の両方について、ドライバーからチェックイン情報を収集します。",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "予約の完了後にチェックアウト情報を収集します。",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "予定された予約でドライバーがセルフチェックインする際に、ドライバー情報を収集します。この機能はゲート管理ソリューションのオプションのアドオンです。",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "入荷貨物に関する損傷、数量差異、その他の問題を記録します。",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "出荷貨物の積載状態やその他のセキュリティ対策を記録します。",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "予約時に荷物の種類ごとの詳細を収集します。",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "ヤードに到着したトレーラーやコンテナの詳細を保存・追跡します。",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "この倉庫で YMS モジュールを有効にし、ゲート管理アプリのアセット訪問項目も有効にします。",
      "enableTheSmartGateModuleForThisWarehouse": "この倉庫で SmartGate モジュールを有効にします。",
      "enableTheIdValidationForThisWarehouse": "この倉庫で本人確認モジュールを有効にします。",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "この倉庫でゲート管理モジュール（チェックインを含む）を有効にします",
      "reviewAndManageAppointmentDataAfterCompletion": "完了後の予約データを確認・管理します。"
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">仕組みを見る</a>か、お問い合わせのうえ<a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">トライアルをお申し込みください</a>。",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">仕組みを見る</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "ドライバーがセルフチェックインする際に、このフォームが表示されます。",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "このフォームのすべての項目が、予約時に<strong>利用可能になり表示されます</strong>。"
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "ドライバーがセルフチェックインする際に、このフォームは表示されません。",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "このフォームのすべての項目が、予約時に<strong>利用できなくなります</strong>。<br />このフォームはいつでも再度有効にできます。"
    },
    "labels": {
      "updateClaimsSupport": "クレーム対応記録を更新",
      "selectAClaimsSupportToUpdate": "更新するクレーム対応記録を選択",
      "damageType": "損傷の種類",
      "damageDescription": "損傷の説明",
      "damagePhotos": "損傷の写真",
      "discrepancyType": "差異の種類",
      "discrepancyDescription": "差異の説明",
      "discrepancyPhotos": "差異の写真",
      "loadSecurityChecked": "積荷の固定確認済み",
      "loadSecurityDescription": "積荷の固定状況の説明",
      "loadIntegrityPhotos": "積載状態の写真",
      "sealIntegrityPhotos": "シールの状態の写真"
    }
  }
}
